
export const BEST_EFFORT_PARSING_DEFAULT_STRING = null;
export const BEST_EFFORT_PARSING_PLACEHOLDER_STRING = 'enter_string';
export const BEST_EFFORT_PARSING_PLACEHOLDER_MULTISELECT = 'make_selection';
export const PLACEHOLDER_STRING = '...';
